import React, { useState } from 'react'
import { PALETTE } from '../../common/ThemeConstants'

import { useNavigate } from 'react-router-dom'

export default function HomeImageCard({ cover, text, to, size = 325 }) {
    const [isCardHover, setIsCardHover] = useState(false)
    const navigate = useNavigate()

    const backgroundColor = isCardHover ? PALETTE.WHITE : PALETTE.LIGHTGRAY
    return (
        <div
            onClick={() => navigate(to)}
            onMouseEnter={() => setIsCardHover(true)}
            onMouseLeave={() => setIsCardHover(false)}
            className={"shadow text-center rounded-md m-auto"}
            style={{
                backgroundColor: backgroundColor,
                border: "0px solid",
                height: size,
                width: size,
                cursor: "pointer"
            }}
        >
            <div style={{ backgroundImage: `url(${cover})`, backgroundSize: "cover", height: "100%", width: "100%" }} className="py-3 px-3">
                <p style={{ fontSize: 22, color: PALETTE.DARKGRAY }}>{text}</p>
            </div>
        </div>
    )
}

